import { fmtMSS } from '~/const/conversion'

export default function formatWork(work) {
  if (!work) return null
  let start = work.publishingStartDate
  let end = work.publishingEndDate
  let title = work.title
  let subtitle = work.descriptionFr
  let subtitleEn = work.descriptionEn
  if (work.editor) {
    subtitle += `${subtitle ? ', ' : ''}${work.editor}`
    subtitleEn += `${subtitleEn ? ', ' : ''}${work.editor}`
  }
  if (work.duration) {
    subtitle += `${subtitle ? ', ' : ''}${fmtMSS(work.duration)}`
    subtitleEn += `${subtitleEn ? ', ' : ''}${fmtMSS(work.duration)}`
  }
  if (start) {
    start = new Date(start).getFullYear()
    title += ` (${start}`
    if (end) {
      end = new Date(end).getFullYear()
      if (end !== start) {
        title += `-${end}`
      }
    }
    title += ')'
  }
  return {
    ...work,
    type: 'work',
    title,
    subtitle,
    subtitleEn,
  }
}
